// eslint-disable-next-line import/prefer-default-export
export default {
  _dataError: null,
  success: false,
  jwt: null,
  idExpires: null,
  uid: null,
  uuid: null,
  email: null,
  username: null,
  country: null,
  subscriptions: null,
  roleIds: [],
  userAccountId: null,
  cacheId: null,
}
